export class Mutex {
	#lock = false;
	#queue = new Set<() => void>();

	async acquire(): Promise<void> {
		if (this.#lock) {
			await new Promise<void>((resolve) => this.#queue.add(resolve));
		}

		this.#lock = true;
	}

	async release(): Promise<void> {
		if (!this.#lock) {
			return;
		}

		this.#lock = false;
		for (const resolve of this.#queue) {
			resolve();
		}
		this.#queue.clear();
	}
}
